import React from "react"

const StoreContext = React.createContext()

const initialState = {
  items: [],
  total: 0,
}

const setLocalStore = cart => {
  localStorage.setItem("shoppingCart", JSON.stringify(cart))
}

const storeReducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case "addItem": {
      const newCart = {
        ...state,
        items: [...(state?.items ?? []), payload],
        total: (state ? state.total : 0) + payload.price,
      }
      setLocalStore(newCart)
      return newCart
    }

    case "removeItem": {
      const newCart = {
        ...state,
        items: state.items.filter(item => item.id !== payload.id),
        total: Math.abs(state.total - payload.price),
      }
      setLocalStore(newCart)
      return newCart
    }

    case "resetStore": {
      const newCart = {
        ...state,
        items: [],
        total: 0,
      }
      setLocalStore(newCart)
      return newCart
    }

    default: {
      throw new Error(`Unhandled action type ${type}`)
    }
  }
}

const StoreProvider = ({ children }) => {
  let localStore = () => {
    if (typeof window !== `undefined`) {
      const store = JSON.parse(localStorage.getItem("shoppingCart"))

      if (!store) {
        setLocalStore(initialState)
      }

      return store
    }
  }

  const [state, dispatch] = React.useReducer(
    storeReducer,
    initialState,
    localStore
  )

  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  )
}

const useStore = () => React.useContext(StoreContext)

export { StoreProvider, useStore }
